<template>

    <v-container class="align-center flex-row mb-6 pa-0">
        <p class="text-headline-small mb-4">Identificazione</p>
        <v-text-field label="Denominazione" required outlined v-model="properties.denominaz"
            @update:model-value="setLabel">
            <template v-slot:append>
                <v-btn size="" color="primary" @click="copy2clipboard(properties.denominaz)" class="pa-4"
                    :disabled="!properties.denominaz">
                    <v-icon>mdi-content-copy</v-icon>
                </v-btn>
            </template>
        </v-text-field>
    </v-container>

    <v-card class="ma-0 mb-6 pa-3" :border="true" flat>

        <p class="text-headline-small">Tipologia</p>
        <v-select v-model="properties.tipologia_id" :items="baseData.lookup.segmentotipologia"
            item-title="label" hide-details class="mb-6" />
        <p class="text-headline-small">Difficoltà</p>
        <v-select v-model="properties.difficolta_id" :items="baseData.lookup.segmentodifficolta"
            item-title="label" hide-details class="mb-6" />
        <p class="text-headline-small">Stato</p>
        <v-select v-model="properties.stato_id" :items="baseData.lookup.segmentostato" item-title="label"
            hide-details class="mb-6" />
        <p class="text-headline-small">Inagibilità</p>
        <v-select v-model="properties.inagibilita_id" :items="baseData.lookup.segmentoinagibilita"
            item-title="label" hide-details class="mb-6" />
        <p class="text-headline-small">Ubicazione</p>
        <v-select v-model="properties.ubicazione_id" :items="baseData.lookup.segmentoubicazione"
            item-title="label" hide-details class="mb-6" />
        <p class="text-headline-small">Fondo</p>
        <v-select v-model="properties.fondo_id" :items="baseData.lookup.segmentofondo" item-title="label"
            hide-details class="mb-6" />
        <p class="text-headline-small">Ambiente</p>
        <v-select v-model="properties.ambiente_id" :items="baseData.lookup.segmentoambiente"
            item-title="label" hide-details class="mb-6" />
        <p class="text-headline-small">Larghezza</p>
        <v-select v-model="properties.larghezza_id" :items="baseData.lookup.segmentolarghezza"
            item-title="label" hide-details class="mb-6" />

    </v-card>




    <v-card class="ma-0 mb-6 pa-3" :border="true" flat>

        <p class="text-headline-small">Segnaletica</p>

        <v-switch inset v-model="properties.segnaletica" class="" hide-details color="primary"
            :label="properties.segnaletica ? 'Presenza di segnaletica' : 'Senza segnaletica'"></v-switch>

    </v-card>

    <SegmentoCommon v-model="properties" />
</template>

<script setup>

import { onMounted } from 'vue'
import SegmentoCommon from "@/reports/components/SegmentoCommon"
import baseData from '@/assets/catalog/TrackerForms.json'
import { useCopyToClipboard } from "@/service/copyToClipboard";
const { copy2clipboard } = useCopyToClipboard();

const setLabel = () => {
    if (properties.value.denominaz) {
        properties.value.label = `${properties.value.denominaz}`
    }
    else {
        properties.value.label = "senza denominazione"
    }
}

const properties = defineModel()

const props = defineProps({
    "isNew": {
        type: Boolean,
        default: false
    }
})

onMounted(() => {
  if (props.isNew) {
    loadDefaults()
  }
})


const loadDefaults = () => {
    properties.value.denominaz = "descrizione_" + properties.value.uuid
    properties.value.tipologia_id = 1
    properties.value.difficolta_id = 1
    properties.value.stato_id = 1
    properties.value.inagibilita_id = null
    properties.value.ubicazione_id = 1
    properties.value.fondo_id = 1
    properties.value.ambiente_id = 1
    properties.value.larghezza_id = 1
    properties.value.segnaletica = 1
}

</script>
